import React, { FC, PropsWithChildren, useRef, useState } from "react"

import {
    useMaskEntryAnimation,
    useRopeEntryAnimation,
    useRopeSwingAnimation,
    useBambooEntryAnimation,
    useBambooSwingAnimation,
} from "@/Topics/Main/Stages/00-Loading/animation"
import styles from "./index.module.scss"

export const Wrapper: FC<{ ready: boolean } & PropsWithChildren> = ({
    ready: _ready,
    children,
}) => {
    const [ropeEntryFinished, setRopeEntryFinished] = useState(false)
    const [bambooLeftEntryFinished, setBambooLeftEntryFinished] =
        useState(false)
    const [bambooRightEntryFinished, setBambooRightEntryFinished] =
        useState(false)
    const maskRef = useRef<HTMLDivElement>(null)
    const ropeRef = useRef<HTMLDivElement>(null)
    const bambooLeftRef = useRef<HTMLImageElement>(null)
    const bambooRightRef = useRef<HTMLImageElement>(null)

    // 应用幕布和绳子进入动画
    useMaskEntryAnimation(maskRef)
    useRopeEntryAnimation(ropeRef, () => {
        // rope 进入动画完成后，启动摆动动画
        setRopeEntryFinished(true)
    })
    useRopeSwingAnimation(ropeRef, ropeEntryFinished)

    // 应用竹子进入动画
    useBambooEntryAnimation(bambooLeftRef, true, () => {
        // 左侧竹子进入动画完成后，启动摆动动画
        setBambooLeftEntryFinished(true)
    })
    useBambooEntryAnimation(bambooRightRef, false, () => {
        // 右侧竹子进入动画完成后，启动摆动动画
        setBambooRightEntryFinished(true)
    })

    // 应用竹子摆动动画
    useBambooSwingAnimation(bambooLeftRef, bambooLeftEntryFinished)
    useBambooSwingAnimation(bambooRightRef, bambooRightEntryFinished)

    return (
        <div className={styles.recall}>
            <img
                ref={bambooLeftRef}
                src={require("@/assets/imgs/common/bamboo_left.png")}
                alt=""
                className={styles.bambooLeft}
            />
            <img
                ref={bambooRightRef}
                src={require("@/assets/imgs/common/bamboo_right.png")}
                alt=""
                className={styles.bambooRight}
            />
            <div ref={maskRef} className={styles.bgMask} />
            <div ref={ropeRef} className={styles.rope} />
            <div className={styles.safeArea}>{children}</div>
        </div>
    )
}
